import store from "../store";

export const redirectHandler = function(input) {
  const redirectUrl = store.state.redirect_url;
  if (redirectUrl) {
    let finalUrl = redirectUrl;

    // If it doesn't start with http:// or https://, add https://
    if (!/^https?:\/\//i.test(redirectUrl)) {
      finalUrl = "https://" + redirectUrl;
    }

    window.location.href = finalUrl;
  } else
    switch (input?.type) {
      case "modal":
        this.$bvModal.hide(input.data);
        break;
      case "redirect":
        this.$router.push(input.data);
        break;
      default:
        window.location.href = "/";
    }
};
